
export const Config = {

  baseURL: "https://api.niemopen.org/v2/",

  selectedNIEMVersionNumber: "6.0",

  initialVisit: true,

  storeLoaded: false,

  useToolTips: true,

  userID: "user",
  username: "User",

}
